import { configureStore } from "@reduxjs/toolkit";
import projectReducer from "./slices/projectSlice";
import sendListsReducer from "./slices/sendListsSlice";
import modalsSliceReducer from "./slices/modalsSlice";
import featuresSliceReducer from "./slices/featuresSlice";
import surveyThemesReducer from "./slices/surveyThemesSlice";
import informationSidepanelReducer from "./slices/informationSidepanelSlice";
import broadcastReducer from "./slices/broadcastSlice";
import { contactsAPI } from "./slices/contactsSlice";
import { mapsAPI } from "./slices/mapsSlice";
import { widgetsAPI, widgetsProxyAPI } from "./slices/widgetsSlice";
import { settingsAPI, settingsProxyAPI } from "./slices/settingsSlice";
import { knowledgeBaseAPI } from "./slices/knowledgeBaseSlice";
import { inboundCampaignProxyAPI } from "./inboundCampaignSlice";
import { broadcastProxyAPI } from "./slices/broadcastAPISlice";
import { projectsProxyAPI } from "./slices/projectsAPISlice";
import { monitoringProxyAPI } from "./slices/monitoringSlice";
import { reportingProxyAPI } from "./slices/reportingSlice";

const reducer = {
  project: projectReducer,
  sendLists: sendListsReducer,
  modals: modalsSliceReducer,
  features: featuresSliceReducer,
  informationSidepanel: informationSidepanelReducer,
  surveyThemes: surveyThemesReducer,
  broadcast: broadcastReducer,
  [contactsAPI.reducerPath]: contactsAPI.reducer,
  [mapsAPI.reducerPath]: mapsAPI.reducer,
  [widgetsAPI.reducerPath]: widgetsAPI.reducer,
  [widgetsProxyAPI.reducerPath]: widgetsProxyAPI.reducer,
  [settingsAPI.reducerPath]: settingsAPI.reducer,
  [settingsProxyAPI.reducerPath]: settingsProxyAPI.reducer,
  [knowledgeBaseAPI.reducerPath]: knowledgeBaseAPI.reducer,
  [broadcastProxyAPI.reducerPath]: broadcastProxyAPI.reducer,
  [projectsProxyAPI.reducerPath]: projectsProxyAPI.reducer,
  [inboundCampaignProxyAPI.reducerPath]: inboundCampaignProxyAPI.reducer,
  [monitoringProxyAPI.reducerPath]: monitoringProxyAPI.reducer,
  [reportingProxyAPI.reducerPath]: reportingProxyAPI.reducer,
};

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware()
    .concat(contactsAPI.middleware)
    .concat(mapsAPI.middleware)
    .concat(widgetsAPI.middleware)
    .concat(widgetsProxyAPI.middleware)
    .concat(settingsAPI.middleware)
    .concat(settingsProxyAPI.middleware)
    .concat(inboundCampaignProxyAPI.middleware)
    .concat(knowledgeBaseAPI.middleware)
    .concat(projectsProxyAPI.middleware)
    .concat(broadcastProxyAPI.middleware)
    .concat(monitoringProxyAPI.middleware)
    .concat(reportingProxyAPI.middleware);

export const createAppStore = (preloadedState) =>
  configureStore({
    reducer,
    middleware,
    ...(preloadedState ? { preloadedState } : {}),
  });

// eslint-disable-next-line import/prefer-default-export
export const store = createAppStore();
